import { notifyOnError } from '~/rage/decorators';
import { Layouts } from '~/shared';
import type { RpcService } from '../RpcService';
import { AbstractGuiService } from './AbstractGuiService';
import { IGuiService } from './guiServiceTypes';

export class GuiService extends AbstractGuiService implements IGuiService {
	constructor(private readonly rpc: RpcService) {
		super();

		console.log('[GUI]: Initializing');

		rpc.register(
			'gui:setLayoutVisible',
			(payload: { name: Layouts; visible: boolean }) => {
				this.setLayoutVisibleState(payload.name, payload.visible);

				console.log(
					`[GUI]: ${payload.name} is ${payload.visible ? 'shown' : 'hidden'}`,
				);
			},
		);

		rpc.register('gui:setFocused', (payload: { focus: boolean }) => {
			mp.invoke('focus', payload.focus);
		});

		rpc.register(
			'gui:setMinimapInfo',
			(payload: { x: number; y: number; width: number; height: number }) => {
				this.minimapInfo.next(payload);
			},
		);
	}

	@notifyOnError
	public async setGameHudVisible(isVisible: boolean): Promise<void> {
		this.rpc.invokeClient('gui:setGameHudVisible', { isVisible });
	}

	@notifyOnError
	public async setCursorVisible(name: string, visible: boolean): Promise<void> {
		return this.rpc.invokeClient('gui:setCursorVisible', { name, visible });
	}

	@notifyOnError
	public async shouldDeclineInvite(): Promise<boolean> {
		return this.rpc.invokeClient('gui:shouldDeclineInvite');
	}
}
